<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row class="center" :gutter="20">
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="accounts" tag="div" class="grid-content bg-purple">
                        <div class="tool_warp">
                            <div>{{$t('l.accountCount')}}</div>
                            <div class="txt">{{info.numberOfAccounts}}</div>
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="asset" tag="div" class="grid-content bg-purple">
                        <div class="grid-content bg-purple">
                            <div class="tool_warp">
                                <div>Transfers</div>
                                <div class="txt">{{info.numberOfTransfers}}</div>
                            </div>
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="48" :sm="24" :md="12" :lg="12">
                    <router-link to="currency" tag="div" class="grid-content bg-purple">
                        <div class="tool_warp">
                            <div class="txt" style="font-size: 14px">{{info.description}}</div>
                        </div>
                    </router-link>
                </el-col>
<!--                <el-col :xs="24" :sm="12" :md="6" :lg="6">-->
<!--                    <router-link to="alias" tag="div" class="grid-content bg-purple">-->
<!--                        <div class="tool_warp">-->
<!--                            <div>{{$t('l.aliasCount')}}</div>-->
<!--                            <div class="txt">{{aliasCount}}</div>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </el-col>-->
            </el-row>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.asset.title1')}}</span>

                </div>
                <el-table class="center"
                          v-loading="Loading"
                          stripe
                          :data="List"
                          style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod"
                            label=""
                            width="60">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.account.addr')"
                            width="'50%'">
                        <template slot-scope="scope">
                            <router-link style="position: relative" :to="'/account/'+scope.row.accountRS">
                                <el-button type="text"> {{scope.row.accountRS}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.account.index.BALANCE')"
                            width="'50%'">
                        <template slot-scope="scope">
                            {{scope.row.quantityQNT}}
                        </template>
                    </el-table-column>

                </el-table>
                <el-pagination
                        style="text-align: center;"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="15"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>

    </el-container>
</template>

<script>
    import fhead from './../fhead.vue';

    export default {
        name: 'account',
        components: {
            fhead
        },
        data() {
            return {
                search: '',
                Loading: false,
                List: [],
                currentPage: 1,
                total: 0,
                currentPageIs: false,
                info: {}
            }
        },
        methods: {
            open(model) {
                console.log(model);
                this.$alert(model.DESCRIPTION, model.NAME, {
                    confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                });
            },
            test() {
                this.currentPage = 1
                this.init()
            },
            indexMethod(index) {
                return (index + 1) + (this.currentPage - 1) * 15;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.accounts();
            },
            init() {
                this.account = this.$route.params.account;
                this.Loading = true;

                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAsset&asset='+this.account+'&includeCounts=true'
                }).then(response1 => {
                    this.info = response1
                    console.log(this.info);
                    this.total = this.info.numberOfAccounts
                    this.Loading = false;
                    this.accounts()
                });


            },
            accounts() {
                this.Loading = true;
                console.log(this.currentPage, "this.currentPage");
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAssetAccounts&asset='+this.account + '&firstIndex=' + (this.currentPage - 1) * 14 + '' +
                        '&lastIndex=' + ((this.currentPage - 1) * 14 + 14)
            }).then(response => {
                    this.Loading = false;
                    this.List = response.accountAssets
                    if (this.List != 15) {
                        this.currentPageIs = false;
                    }
                });
            }

        },
        created: function () {
            this.init();
        }
    }
</script>

<style scoped lang="less">
    .tool_warp {
        padding: 20px;

        div {
            color: #fff;
        }

        .txt {
            text-align: right;
            font-size: 18px;
        }
    }

    .bg-purple {
        background: #58b3f9;
    }

    .grid-content {
        cursor: pointer;
        margin-top: 10px;
        border-radius: 4px;
        min-height: 36px;
    }
</style>




// WEBPACK FOOTER //
// src/components/asset/account.vue